/** ໂຊວໃນ catalog CF: ມີ stock ເພີ່ມໄດ້ ຫຼື ເປີດ preorder ຢູ່ */
export function isCfCatalogEligible(item: {
  availableToAdd: number;
  isPreorder: boolean;
}): boolean {
  return item.availableToAdd > 0 || item.isPreorder;
}
